import React, { useState } from 'react';

import styled from 'styled-components';

import { desktop } from '../../styles';
import { Component as VIPLearnMoreModal } from '../VIPLearnMoreModal';

import { GuestSection } from './GuestSection';
import { Header } from './Header';
import { MemberSection } from './MemberSection';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;

  position: fixed;
  inset: 0;
  overflow-y: scroll;
  z-index: 999;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;

  ${desktop`
    flex-direction: row;
  `}
`;

interface MembershipModalProps {
  guestPrice: number;
  memberPrice: number;
  membershipPrice: number;
  isLoggedIn: boolean;
  onContinueAsMember: () => void;
  onContinueAsGuest: () => void;
  onCancel: () => void;
}

export const MembershipModal = ({
  guestPrice,
  memberPrice,
  membershipPrice,
  isLoggedIn,
  onContinueAsMember,
  onContinueAsGuest,
  onCancel,
}: MembershipModalProps) => {
  const [isVIPLearnMoreModalOpen, setIsVIPLearnMoreModalOpen] = useState(false);

  const onLearnMoreClick = () => setIsVIPLearnMoreModalOpen(true);

  const onCloseLearnMoreModal = () => setIsVIPLearnMoreModalOpen(false);

  return (
    <Container>
      <VIPLearnMoreModal
        // @ts-ignore
        isOpen={isVIPLearnMoreModalOpen}
        onExit={onCloseLearnMoreModal}
      />
      <Header onCancel={onCancel} isLoggedIn={isLoggedIn} />
      <Content>
        <MemberSection
          guestPrice={guestPrice}
          memberPrice={memberPrice}
          membershipPrice={membershipPrice}
          onLearnMoreClick={onLearnMoreClick}
          onContinueAsMember={onContinueAsMember}
          onContinueAsGuest={onContinueAsGuest}
        />
        <GuestSection
          guestPrice={guestPrice}
          onContinueAsGuest={onContinueAsGuest}
        />
      </Content>
    </Container>
  );
};
